import { Injectable } from '@angular/core';
import {
  CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';

export interface FormComponentCanDeactivate {
  SamplecanDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({
  providedIn: 'root'
})
export class DirtyFormGuard implements CanDeactivate<any> {
  component: Object;
  route: ActivatedRouteSnapshot;
  canDeactivate(
    component: FormComponentCanDeactivate,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    return component.SamplecanDeactivate
      ? component.SamplecanDeactivate()
      : true;
  }
}
